import _ from 'lodash';

const createTranslate = (translationsOrFactory) => (key, context) => {
  const translations = _.isFunction(translationsOrFactory)
    ? translationsOrFactory()
    : translationsOrFactory;
  const value = _.get(translations, key);

  if (!value) {
    return '';
  }

  if (!context) {
    return value;
  }

  try {
    return _.template(value, {
      interpolate: /{{([\s\S]+?)}}/g,
    })(context);
  } catch (e) {
    if (!TEST) {
      console.warn(`Unable to interpolate translation ${key}: ${value}`);
    }
    return '';
  }
};

export default createTranslate;
